var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarGolden = function SvgStarGolden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE600",
    d: "m7.658.867 1.058 2.13c.142.294.525.574.847.634l1.913.317c1.222.204 1.507 1.095.63 1.986l-1.493 1.503c-.247.249-.39.74-.307 1.094l.427 1.858c.338 1.465-.442 2.039-1.725 1.269l-1.792-1.073c-.323-.196-.863-.196-1.185 0l-1.793 1.072c-1.283.763-2.063.197-1.725-1.268L2.94 8.53c.068-.362-.075-.853-.322-1.102L1.125 5.926c-.877-.883-.592-1.774.63-1.985l1.913-.318c.322-.052.705-.34.847-.634L5.573.86C6.151-.287 7.081-.287 7.658.868"
  })));
};
export default SvgStarGolden;